import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      textAlign: 'center',
      paddingTop: theme.spacing(1)
    },
    subtitle: {
      paddingTop: theme.spacing(1.5)
    }
  };
});

const SupportHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('Support');
  return (
    <div className={classes.root}>
      <Typography variant="h2">{t('How Can We Help?')}</Typography>
      <Typography className={classes.subtitle} variant="subtitle1">
        {t(
          'Type in a search criteria or select one of our products to find the answer you are looking for.'
        )}
      </Typography>
    </div>
  );
};

export default SupportHeader;
